// 首页静态展示数据 —— 全站仅供浏览，不接入真实接口
export type TickerItem = { time: string; label: string };

export const tickerItems: TickerItem[] = [
  { time: "23:58", label: "深夜新瓜上架：某剧组聚餐照流出，围观众人反应微妙" },
  { time: "23:12", label: "更新：带货主播致歉声明全文已补发，评论区风向再变" },
  { time: "22:41", label: "爆料：某选秀常驻导师行程成谜，节目组暂未回应" },
  { time: "21:57", label: "追踪：机场偶遇照片新增三张，同行人身份存疑" },
  { time: "21:15", label: "快讯：品牌方删除合作动态，圈内猜测自动续约生变" },
  { time: "20:36", label: "新瓜：晚会彩排路透流出，站位与上月物料大不同" },
  { time: "19:52", label: "更新：粉丝团声明回应近期争议，强调理性沟通" },
  { time: "19:08", label: "爆料：商务群聊截图疯转，报价口径不一引热议" },
];

export const hotTags: string[] = [
  "剧组互撕", "带货翻车", "选秀塌房", "合约纠纷", "机场偶遇",
  "晚会站位", "深夜幽会", "商务报价", "直播嘴瓢", "旧照考古",
  "官方声明", "狗仔蹲拍",
];

export type Briefing = { time: string; title: string; tag: string; views: string };

export const briefings: Briefing[] = [
  { time: "20:15", title: "《深夜片场》剧方发声明：冲突录音系剪辑拼接，保留追责权利", tag: "剧组", views: "18.6万" },
  { time: "19:02", title: "某网红夫妇联动直播中途黑屏，售后热线被打爆，平台介入核查", tag: "带货", views: "32.1万" },
  { time: "17:44", title: "选秀 C 位机场造型引旧照考古，造型团队发长文回应风格争议", tag: "选秀", views: "9.8万" },
  { time: "15:30", title: "两大品牌同时撤下代言物料，商务圈报价单版本之争继续发酵", tag: "商务", views: "27.4万" },
  { time: "12:18", title: "晚会彩排路透流出，站位疑似调整，节目组未予置评", tag: "晚会", views: "15.2万" },
  { time: "10:05", title: "狗仔蹲拍视频更新：收工后同车离开画面被放大逐帧解析", tag: "蹲拍", views: "21.7万" },
];

export type MiniUpdate = { time: string; title: string; tag: string };

export const miniUpdates: MiniUpdate[] = [
  { time: "23:12", title: "主播致歉声明全文已补发", tag: "声明" },
  { time: "22:41", title: "选秀导师行程成谜引猜测", tag: "行程" },
  { time: "21:57", title: "机场偶遇照片新增三张", tag: "偶遇" },
  { time: "21:15", title: "品牌方删除合作动态", tag: "商务" },
  { time: "20:36", title: "晚会彩排站位路透流出", tag: "路透" },
];

export type RankItem = { rank: number; title: string; heat: string; trend: "up" | "flat" | "down" };

export const hotRank: RankItem[] = [
  { rank: 1, title: "剧组互撕录音：谁在说谎，行业人怎么看", heat: "428万", trend: "up" },
  { rank: 2, title: "带货翻车七日：售后、平台与品牌的三方拉扯", heat: "395万", trend: "up" },
  { rank: 3, title: "选秀塌房风向再变，粉丝团深夜发声明", heat: "367万", trend: "up" },
  { rank: 4, title: "机场旧照考古：同一个 C 位，两种营业状态", heat: "241万", trend: "flat" },
  { rank: 5, title: "品牌删除动态背后：报价口径为何对不上", heat: "198万", trend: "up" },
  { rank: 6, title: "晚会站位疑云：三张路透的逐帧比对", heat: "166万", trend: "down" },
];

export type CollectionTopic = {
  id: string;
  name: string;
  subtitle: string;
  count: string;
  accent: string;
  image: string;
  items: { title: string; heat: string; time: string }[];
};

export const collections: CollectionTopic[] = [
  {
    id: "star",
    name: "明星动态",
    subtitle: "行程、营业与剧组日常，一手蹲点实录",
    count: "今日 +12",
    accent: "bg-primary-500",
    image: "https://readdy.ai/api/search-image?query=empty%20backstage%20vanity%20dressing%20room%20with%20warm%20glowing%20mirror%20lights%20and%20costume%20racks%2C%20cinematic%20editorial%20press%20photography%2C%20deep%20crimson%20and%20warm%20amber%20accents%2C%20shallow%20depth%20of%20field%2C%20soft%20shadows%2C%20high-end%20magazine%20atmosphere%2C%20moody%20and%20private&width=900&height=620&seq=topic-star&orientation=landscape",
    items: [
      { title: "深夜片场收工照：状态 vs 营业，网友逐帧开扒", heat: "86万", time: "30分钟前" },
      { title: "常驻导师行程空白期，节目组口径前后不一", heat: "72万", time: "1小时前" },
      { title: "同款出镜三连：巧合还是宣传？造型团队回应", heat: "64万", time: "2小时前" },
      { title: "杂志内页旧物料翻出，造型争议再被点名", heat: "51万", time: "3小时前" },
    ],
  },
  {
    id: "net",
    name: "网红现场",
    subtitle: "直播间与带货台前幕后，全程不间断记录",
    count: "今日 +9",
    accent: "bg-accent-500",
    image: "https://readdy.ai/api/search-image?query=empty%20live%20streaming%20studio%20with%20large%20ring%20light%20and%20smartphone%20on%20tripod%20facing%20an%20empty%20chair%2C%20warm%20cinematic%20editorial%20lighting%20with%20crimson%20and%20amber%20tones%2C%20shallow%20depth%20of%20field%2C%20clean%20modern%20interior%2C%20high-end%20magazine%20look%2C%20slightly%20moody&width=900&height=620&seq=topic-net&orientation=landscape",
    items: [
      { title: "联动直播中断后续：售后、平台与主播的三方回应", heat: "98万", time: "20分钟前" },
      { title: "直播嘴瓢片段刷屏，切片在社交平台二次发酵", heat: "67万", time: "1小时前" },
      { title: "报价单流传：同一场带货，三个版本口径", heat: "59万", time: "2小时前" },
      { title: "停播一天后的声明：粉丝 vs 路人评论两极", heat: "44万", time: "4小时前" },
    ],
  },
  {
    id: "scene",
    name: "圈内风向",
    subtitle: "晚会、颁奖与品牌活动的站位与暗流",
    count: "今日 +6",
    accent: "bg-secondary-600",
    image: "https://readdy.ai/api/search-image?query=empty%20grand%20awards%20stage%20with%20warm%20spotlight%20and%20microphone%20lectern%20center%2C%20draped%20crimson%20curtains%2C%20atmospheric%20cinematic%20editorial%20photography%20with%20amber%20and%20deep%20red%20tones%2C%20shallow%20depth%20of%20field%2C%20elegant%20and%20dramatic%2C%20high-end%20magazine%20quality&width=900&height=620&seq=topic-scene&orientation=landscape",
    items: [
      { title: "晚会站位疑云：路透、红毯与最终图对比", heat: "83万", time: "40分钟前" },
      { title: "颁奖礼同框图流传，圈内人私下如何点评", heat: "61万", time: "2小时前" },
      { title: "品牌晚宴名单外流，站位表被逐格标注", heat: "48万", time: "3小时前" },
      { title: "周年红毯着装争议：谁的造型团队背锅", heat: "39万", time: "5小时前" },
    ],
  },
  {
    id: "track",
    name: "事件追踪",
    subtitle: "从头条到收尾，全程时间线持续更新",
    count: "持续跟",
    accent: "bg-primary-700",
    image: "https://readdy.ai/api/search-image?query=overhead%20view%20of%20cluttered%20editorial%20news%20desk%20with%20open%20folders%20printed%20pages%20and%20warm%20desk%20lamp%20glow%2C%20dark%20moody%20atmosphere%20with%20amber%20highlights%20and%20deep%20crimson%20shadows%2C%20cinematic%20investigative%20journalism%20photography%2C%20shallow%20depth%20of%20field%2C%20high-end%20magazine%20editorial%20look&width=900&height=620&seq=topic-track&orientation=landscape",
    items: [
      { title: "剧组互撕事件时间线：从首曝到双方回应", heat: "112万", time: "追踪中" },
      { title: "带货翻车七日观察：平台介入后的最新动作", heat: "95万", time: "追踪中" },
      { title: "选秀塌房舆情复盘：声明前后的关键时间点", heat: "77万", time: "追踪中" },
      { title: "报价单风波进展：版本源头仍待核实", heat: "58万", time: "追踪中" },
    ],
  },
];

export type StreamItem = {
  image: string;
  tag: string;
  title: string;
  desc: string;
  time: string;
  read: string;
  hot?: boolean;
  level: string;
};

export const streamItems: StreamItem[] = [
  {
    image: "https://readdy.ai/api/search-image?query=silhouetted%20concert%20stage%20performer%20with%20confetti%20falling%20under%20deep%20crimson%20and%20amber%20stage%20lights%2C%20cinematic%20editorial%20live%20music%20photography%2C%20moody%20warm%20color%20grade%2C%20shallow%20depth%20of%20field%2C%20high-end%20magazine%20atmosphere%2C%20no%20visible%20faces&width=1000&height=660&seq=stream-1&orientation=landscape",
    tag: "现场",
    title: "被曝收工后同车离开：同框三小时成今日最大新瓜",
    desc: "蹲拍视频逐帧解析走红，同车离开的起点与终点被网友标注对比，双方目前均未公开回应。",
    time: "8分钟前",
    read: "32万",
    hot: true,
    level: "🔥 高热",
  },
  {
    image: "https://readdy.ai/api/search-image?query=close%20up%20of%20smartphone%20screen%20glowing%20with%20layered%20chat%20message%20bubbles%20on%20warm%20marble%20desk%20at%20night%2C%20cinematic%20editorial%20digital%20gossip%20photography%2C%20crimson%20and%20amber%20bokeh%20in%20background%2C%20shallow%20depth%20of%20field%2C%20moody%20high-end%20magazine%20look&width=1000&height=660&seq=stream-2&orientation=landscape",
    tag: "聊天",
    title: "商务群聊截图疯转：报价口径不一，当事人晒原图",
    desc: "流传版本与当事人晒出的原图存在出入，孰真孰假引发逐屏比对，评论区吵成一片。",
    time: "22分钟前",
    read: "18万",
    level: "新瓜",
  },
  {
    image: "https://readdy.ai/api/search-image?query=crowd%20of%20fans%20raising%20smartphones%20taking%20photos%20in%20warm%20amber%20event%20light%20with%20blurred%20crimson%20stage%20glow%20behind%2C%20cinematic%20editorial%20paparazzi%20crowd%20photography%2C%20shallow%20depth%20of%20field%2C%20cohesive%20warm%20color%20grade%2C%20high-end%20magazine%20quality%2C%20faces%20softly%20blurred&width=1000&height=660&seq=stream-3&orientation=landscape",
    tag: "偶遇",
    title: "机场偶遇再更新：口罩遮面仍被一眼认出，随行人员成焦点",
    desc: "新增路透中随行人员遮挡镜头引发讨论，粉丝团呼吁勿过度打扰，围观热度不减。",
    time: "41分钟前",
    read: "27万",
    level: "高热",
  },
  {
    image: "https://readdy.ai/api/search-image?query=film%20crew%20holding%20clapperboard%20on%20set%20with%20warm%20tungsten%20lighting%20and%20crimson%20accent%20glow%2C%20empty%20set%20pieces%20blurred%20in%20background%2C%20cinematic%20editorial%20behind%20the%20scenes%20photography%2C%20shallow%20depth%20of%20field%2C%20amber%20and%20deep%20red%20tones%2C%20high-end%20magazine%20look&width=1000&height=660&seq=stream-4&orientation=landscape",
    tag: "剧组",
    title: "深夜片场互撕录音流出，导演喊话：剪辑拼接，已取证",
    desc: "录音完整版与现场同事说法冲突，剧方声明保留法律追责权利，行业人私下怎么看。",
    time: "1小时前",
    read: "51万",
    hot: true,
    level: "🔥 高热",
  },
  {
    image: "https://readdy.ai/api/search-image?query=two%20distant%20silhouettes%20meeting%20in%20dramatic%20empty%20doorway%20with%20long%20warm%20shadows%20and%20crimson%20rim%20light%2C%20mysterious%20cinematic%20editorial%20photography%2C%20moody%20amber%20and%20deep%20red%20color%20grade%2C%20shallow%20depth%20of%20field%2C%20high-end%20magazine%20suspense%20atmosphere%2C%20no%20identifiable%20features&width=1000&height=660&seq=stream-5&orientation=landscape",
    tag: "约见",
    title: "深夜同框疑云再起：会面地点被扒出是常去私房菜馆",
    desc: "狗仔镜头下同框画面流传，地点与上月被拍地点相同，圈内猜测自动续约生变。",
    time: "2小时前",
    read: "39万",
    level: "追踪",
  },
  {
    image: "https://readdy.ai/api/search-image?query=stylist%20hands%20adjusting%20colorful%20garments%20on%20clothing%20rack%20in%20warm%20backstage%20light%20with%20crimson%20and%20amber%20bokeh%2C%20cinematic%20editorial%20fashion%20backstage%20photography%2C%20shallow%20depth%20of%20field%2C%20high-end%20magazine%20atmosphere%2C%20no%20faces&width=1000&height=660&seq=stream-6&orientation=landscape",
    tag: "造型",
    title: "造型团队发长文回应争议：一稿到定稿改了七版",
    desc: "从机场旧照考古到造型声明，当事人晒出沟通记录，围观众说纷纭，评论区开起庭会。",
    time: "3小时前",
    read: "24万",
    level: "新瓜",
  },
  {
    image: "https://readdy.ai/api/search-image?query=empty%20red%20carpet%20with%20velvet%20rope%20and%20warm%20bokeh%20stage%20lights%20at%20night%2C%20crimson%20and%20amber%20cinematic%20editorial%20event%20photography%2C%20moody%20elegant%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20high-end%20magazine%20quality%2C%20no%20people&width=1000&height=660&seq=stream-7&orientation=landscape",
    tag: "晚会",
    title: "晚会站位疑云：路透、红毯与最终物料三方对不上",
    desc: "三张图的站位被逐帧比对，谁靠中间谁站边缘一目了然，节目组与艺人方均未置评。",
    time: "4小时前",
    read: "30万",
    level: "热议",
  },
  {
    image: "https://readdy.ai/api/search-image?query=hand%20scrolling%20glowing%20phone%20screen%20at%20night%20against%20blurred%20city%20bokeh%20in%20crimson%20and%20amber%20tones%2C%20cinematic%20editorial%20social%20media%20photography%2C%20moody%20shallow%20depth%20of%20field%2C%20high-end%20magazine%20investigative%20look&width=1000&height=660&seq=stream-8&orientation=landscape",
    tag: "声明",
    title: "主播致歉声明全文补发：三个时间点被网友核对",
    desc: "声明中提到的处理时间与聊天记录能否对应，成为舆论焦点，热搜词条持续霸榜。",
    time: "5小时前",
    read: "45万",
    hot: true,
    level: "🔥 高热",
  },
];

export type Stage = { label: string; title: string; time: string; text: string; state: string };

export const timelineEvent = {
  title: "剧组互撕 · 录音门全程时间线",
  desc: "从深夜首曝到双方发声，我们持续核对原片、录音与各路说法，按时间顺序整理每一次关键更新。",
  stages: [
    { label: "首曝", title: "深夜录音片段流出", time: "两日前 · 23:47", text: "一段自称片场冲突的录音在群聊扩散，声音辨析引发第一轮讨论。", state: "done" },
    { label: "发酵", title: "当事人同事发声", time: "一日前 · 09:20", text: "多位剧组工作人员匿名表态，对录音语境给出不同描述，版本开始分化。", state: "done" },
    { label: "回应", title: "导演喊话：剪辑拼接", time: "一日前 · 18:33", text: "导演发长文否认冲突，指录音经拼接，声明保留法律追责权利。", state: "done" },
    { label: "新证", title: "现场同事说法流出", time: "今日 · 10:12", text: "自称在场人士晒出工作记录，与录音时间线出现多处出入，待核实。", state: "doing" },
    { label: "待更", title: "后续回应 / 处理结果", time: "持续更新", text: "双方是否进一步发声、平台与行业如何表态，本站将持续追踪。", state: "todo" },
  ],
};

export type DownloadFeature = { icon: string; title: string; desc: string };

export const downloadFeatures: DownloadFeature[] = [
  { icon: "ri-flashlight-line", title: "秒级推送", desc: "最新爆料第一时间弹窗提醒，不错过任何新瓜" },
  { icon: "ri-file-list-3-line", title: "专题合集", desc: "按事件整理的完整时间线，一口气看完全程" },
  { icon: "ri-moon-clear-line", title: "无打扰模式", desc: "重要更新才打扰，日常快讯静默归档可查" },
];

export const footerLinks: { title: string; links: string[] }[] = [
  { title: "内容板块", links: ["今日快讯", "最新爆料", "新瓜热榜", "题材合集", "事件追踪"] },
  { title: "帮助中心", links: ["投稿与线索", "版权声明", "纠错与申诉", "转载规范", "联系我们"] },
];